import * as React from 'react';
import './Popup.css';
import PopupContext from 'contexts/PopupContext';
const Popup = React.forwardRef(({ children, close, style, }, ref) => {
    const popupRef = React.useRef(null);
    const [blockClose, setBlockClose] = React.useState(false);
    React.useImperativeHandle(ref, () => {
        return popupRef.current ?? document.createElement('div');
    }, []);
    const checkContains = React.useCallback((element, x, y) => {
        const rect = element.getBoundingClientRect();
        const height = Math.max(rect.height, element.clientHeight);
        const width = Math.max(rect.width, element.clientWidth);
        // console.log('RectLeft: %o, clientX: %o, RectLeft + width: %o', rect.left, event.clientX, rect.left + width);
        // console.log('RectTop: %o, clientY: %o, RectTop + height: %o', rect.top, event.clientY, rect.top + height);
        if (rect.left <= x && x <= rect.left + width && rect.top <= y && y <= rect.top + height) {
            return true;
        }
        const children = element.children;
        for (let i = 0; i < children.length; i++) {
            const child = children.item(i);
            if (child !== null) {
                const isContained = checkContains(child, x, y);
                if (isContained) {
                    return true;
                }
            }
        }
        return false;
    }, []);
    React.useEffect(() => {
        const abortController = new AbortController();
        const onClick = (event) => {
            if (popupRef.current !== null && event.isTrusted && !blockClose) {
                const isContained = checkContains(popupRef.current, event.clientX, event.clientY);
                if (!isContained) {
                    console.log("Closing popup");
                    close();
                }
            }
        };
        document.addEventListener('mouseup', () => {
            document.addEventListener('click', onClick, { once: true, signal: abortController.signal });
        }, { signal: abortController.signal });
        return () => abortController.abort();
    }, [checkContains, blockClose, close]);
    return (React.createElement(PopupContext, { value: { setBlockClose } },
        React.createElement("div", { ref: popupRef, className: "co-popup", style: style }, children)));
});
export default Popup;
